var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 14C27.9706 14 32 18.0294 32 23C32 27.9706 27.9706 32 23 32C18.0294 32 14 27.9706 14 23C14 18.0294 18.0294 14 23 14ZM23 18C22.4478 18 22 18.4477 22 19V22H19C18.4477 22 18 22.4478 18 23C18 23.5522 18.4477 24 19 24H22V27C22 27.5522 22.4478 28 23 28C23.5522 28 24 27.5522 24 27V24H27C27.5522 24 28 23.5522 28 23C28 22.4478 27.5522 22 27 22H24V19C24 18.4477 23.5522 18 23 18ZM14.5143 16C12.9436 17.9019 12 20.3408 12 23C12 24.04 12.1443 25.0462 12.414 25.9996L12.1204 26.0016C7.06535 26.0016 4.19533 24.3123 4.00962 20.9075L4 20.5492V19C4 17.4406 5.18977 16.1591 6.71108 16.0137L7 16H14.5143ZM12 4C14.7619 4 17.0008 6.23894 17.0008 9.0008C17.0008 11.7627 14.7619 14.0016 12 14.0016C9.23812 14.0016 6.99918 11.7627 6.99918 9.0008C6.99918 6.23894 9.23812 4 12 4ZM22 6C24.2092 6 26 7.79086 26 10C26 10.8314 25.7464 11.6036 25.3122 12.2434C24.5666 12.0839 23.7932 12 23 12C21.6152 12 20.2904 12.2559 19.0698 12.7229C18.406 12.0089 18 11.0518 18 10C18 7.79086 19.7909 6 22 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribeIcon);
export default __webpack_public_path__ + "static/media/subscribeIcon.4ff14c8fbffed44efb0b4471beeecf71.svg";
export { ForwardRef as ReactComponent };